<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('container.containers') }}
        </span>
        <h3 class="page-title">
          {{ $t('container.addingNewContainer') }}
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/kontenery')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('container.addContainer') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <validation-observer ref="container-new-form" tag="form">
        <d-card class="mb-5">
          <d-tabs card v-if="!loadError">
            <!-- Dane ogólne -->
            <d-tab
              :title="$t('ui.generalInfo')"
              active>
              <h4 class="mb-3 pb-3 border-bottom">
                {{ $t('ui.generalInfo') }}
              </h4>

              <div class="form-group">
                <label>
                  {{ $t('container.containerNumber') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="number"
                  v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="number" />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('ui.deliveryDate') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="date"
                  v-slot="{ errors }">
                  <d-datepicker
                    v-model="date"
                    :monday-first="true"
                    format="yyyy-MM-dd"
                    :placeholder="$t('ui.chooseDate')"
                    :state="errors.length ? 'invalid' : null"
                    :language="translationsForDatePicker" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('product.fileWithProducts') }}:
                </label>

                <file-input
                  :onChange="setImportFile"
                  id="inputImportFile" />
              </div>
            </d-tab>

            <d-tab :title="$t('product.products')">
                <p class="text-center">
                  {{ $t('container.productManagementAvailableAfterContainerSave') }}
                </p>
            </d-tab>
          </d-tabs>

          <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center overlay-loading">
            {{ $t('ui.dataLoading') }}&hellip;
          </div>

          <d-alert
            v-if="loadError"
            show
            theme="warning">
            {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
          </d-alert>
        </d-card>
      </validation-observer>
    </d-form>

    <d-modal
      v-if="displayImportResultsPopup"
      size="lg"
      @close="hideImportResultsPopup">
      <d-modal-header>
        <d-modal-title>
          {{ $t('container.importResults') }}
        </d-modal-title>
      </d-modal-header>
      <d-modal-body class="p-0">
        <table class="table mt-0 mb-0 full-width">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0 pl-4">{{ $t('product.productCode') }}</th>
              <th scope="col" class="border-0">{{ $t('ui.amount') }}</th>
              <th scope="col" class="border-0">{{ $t('container.result') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(resultData, index) of importResults"
              :key="'import-results-' + index">
              <td class="align-middle pl-4">
                {{ resultData.code }}
              </td>
              <td class="align-middle">
                {{ resultData.quantity }} {{ $t('ui.piecesAbbr') }}
              </td>
              <td class="align-middle">
                <span
                  v-if="resultData.result"
                  class="text-success">
                  {{ $t('container.importSuccessfull') }}
                </span>
                <span
                  v-else
                  class="text-danger">
                  {{ $t('product.productWithGivenCodeNotFound') }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </d-modal-body>
      <d-modal-footer>
        <d-button
          class="ml-0"
          theme="danger"
          @click.prevent="hideImportResultsPopup">
          {{ $t('ui.close') }}
        </d-button>
      </d-modal-footer>
    </d-modal>
  </d-container>
</template>

<script>
import datepickerTranslations from './../../data/datepicker-translations.js';
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';
import getPrefferedLanguage from './../../utils/i18nUtils.js';

export default {
  name: 'container-new',
  computed: {
    allDataLoaded () {
      return true;
    },
    translationsForDatePicker () {
      return datepickerTranslations[getPrefferedLanguage()];
    }
  },
  data() {
    return {
      number: '',
      date: '',
      file: '',
      loadError: false,
      displayImportResultsPopup: false,
      importResults: [],
      redirectAfterImport: null
    };
  },
  methods: {
    setImportFile (event) {
      this.file = event.target.files[0];
    },
    validateForm () {
      FormUtils.validate(this.$refs['container-new-form'], this.submitForm);
    },
    submitForm () {
      let fileFields = false;
      let formDataToSend = {
        number: this.number,
        date: this.date ? [this.date.getFullYear(), this.date.getMonth() + 1, this.date.getDate()].map(n => n < 10 ? '0' + n : n).join('-') : null
      };

      if (this.file) {
        formDataToSend.file = this.file;
        fileFields = ['file'];
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/products/containers/store',
        formData: formDataToSend,
        successTitle: this.$t('container.addContainerSuccessTitle'),
        successText: this.$t('container.addContainerSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('container.addContainerErrorText'),
        skipSuccessMessage: true,
        successAction: (responseData) => {
          Vue.nextTick(() => {
            this.displayImportResultsPopup = true;
            this.importResults = responseData.results;
            this.redirectAfterImport = parseInt(responseData.id, 10);
          });
        }
      }, fileFields);
    },
    hideImportResultsPopup () {
      this.displayImportResultsPopup = false;
      this.$router.push('/kontenery/edycja/' + this.redirectAfterImport);
    }
  }
};
</script>
